import { JobPriority } from "@shared/jobs-and-billing-priority";
import { IBaseCard } from "./base-card.interface";
import { ComputedCard, CosmosEntity } from "./card-basics.interface";

export interface JobsBillingCard extends CosmosEntity, ComputedCard {
    id: string;
    cardId: string;
    dashboardId: string;
    name: string | null;
    job: {
        id: string;
        statusId: string;
        statusDate: number | null;
        statusUserId: string | null;
        typeId: number;
        priority: JobPriority;
        group1: string | null;
        group2: string | null;
        currentlyResponsible: string | null;
        manager: string | null;
        partner: string | null;
        owner: string;
        targetStartDate: number | null;
        targetEndDate: number | null;
        periodEndDate: number;
        resources: {
            allocated: {
                userId: string;
                roleId: string;
                targeStartDate: number;
                targetEndDate: number;
            }[];
            nonAllocated: {
                userId: string;
                roleId: string;
                targetStartDate: number;
                targetEndDate: number;
            }[];
        };
    };
    return: {
        productType: string;
        documentId: string;
        returnId: number;
    };
    contactInformation: {
        iFirmContactId: string;
        firstName: string | null;
        lastName: string | null;
        phone: string | null;
        cellPhone: string | null;
        email: string | null;
        group1: string | null;
        group2: string | null;
        manager: string | null;
        partner: string | null;
        clientCode: string | null;
    };
    statusesHistory: Array<{
        statusId: string;
        statusDate: number;
        userId: string;
    }>;
    note: string | null;
    documentsReceivedDate: number | null;
}

export function isJobsBillingCard(card: IBaseCard): card is JobsBillingCard {
    return "job" in card && card.job != null && card.job.id !== undefined;
}
